/** Small red ticket badge for $27 audit → Monitor credit. */
export default function AuditCreditBadge({ className = '', label = '$27 OFF' }) {
  return (
    <span
      className={`inline-flex items-center rounded border border-red-500/60 bg-red-600 px-1.5 py-0.5 text-[10px] font-bold uppercase leading-none tracking-wide text-white shadow-sm ${className}`}
      title="Your $27 audit becomes credit on your first Monitor month"
    >
      {label}
    </span>
  );
}
